import dayjs from 'dayjs';
var isDateFuture = function (date, comparableDate) {
    return dayjs(comparableDate).isBefore(dayjs(date));
};
export default isDateFuture;
